import React, { useEffect, useState } from 'react';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import HeroSection from "components/custom/devcommunity/Hero.js";
import DeveloperResources from "components/custom/devcommunity/Resources.js";
import CommunityProjects from "components/custom/devcommunity/Projects.js";
import CtaSection from "components/custom/devcommunity/Cta.js";
import Why from "components/custom/devcommunity/Why.js";
import Footer from "components/custom/Footer.js";
import { Helmet } from 'react-helmet';
import defaultContent from 'translations/devcommunity/en.js'
import Content from "_content/Content.js";


const ldJson2 = Content.structured.ldJson9
const ldJson3 = Content.structured.ldJson3

export default ({ language, translationsFolder }) => {

  const [translations, setTranslations] = useState(defaultContent);

  useEffect(() => {
    if (language !== 'en') {
      import(`translations/${translationsFolder}/${language}.js`)
        .then(module => setTranslations(module.default))
        .catch(error => console.error(`Failed to load translations: ${error}`));
    }
    else {
      setTranslations(defaultContent)
    }
  }, [language]);

  const locationString = `/devcommunity/`

  const locationStringTranslated = translations.pageInfo.locationString
  const descriptionTranslated = translations.pageInfo.description
  const titleTranslated = translations.pageInfo.title

  return (
    <>
      <Helmet>
        <title>{titleTranslated}</title>
        <meta name="description" content={descriptionTranslated} />
        <meta property="title" content={titleTranslated} />
        <link rel="canonical" href={'https://www.gunbot.com' + locationStringTranslated} />
        <meta property="og:locale" content={language + '_' + language.toUpperCase()} />
        <meta property="og:type" content="website" />
        <meta property="og:hashtag" content="#gunbot" />
        <meta property="og:title" content={titleTranslated} />
        <meta property="og:url" content={'https://www.gunbot.com' + locationStringTranslated} />
        <meta property="og:image" content="https://www.gunbot.com/gunbotcom-fb-preview.png" />
        <meta property="og:site_name" content="Gunbot.com" />
        <meta name="twitter:card" content="Gunbot" />
        <meta name="twitter:site" content="https://www.gunbot.com/" />
        <meta name="twitter:title" content="Gunbot. Community made crypto trading bot" />
        <meta name="twitter:description" content="Trade crypto like a boss." />
        <meta property="og:image" content="https://www.gunbot.com/gunbotcom-x-preview.png" />
        <meta property="og:description" content={descriptionTranslated} />
        <html lang={language} />
        <meta http-equiv="Content-Language" content={language} />
        <link rel="alternate" hreflang='es' href={'https://www.gunbot.com' + locationStringTranslated} />
        <link rel="alternate" hreflang="x-default" href={'https://www.gunbot.com' + locationString} />
        <script type="application/ld+json">
          {JSON.stringify(ldJson2)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(ldJson3)}
        </script>
      </Helmet>
      <AnimationRevealPage>
        <HeroSection translations={translations} />
        <Why translations={translations} />
        <CommunityProjects translations={translations} />
        <DeveloperResources translations={translations} />
        <CtaSection translations={translations} />
        <Footer />
      </AnimationRevealPage>
    </>
  );
}
